/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";
import MolGrid from "../../../components/grid/MolGrid";
import SwalAlert from "../../../services/swalService/SwalService";
import CenterModel from "../../../components/ui/centerModel/CenterModel";
/** Common Services & Data Files */
import { decryptUrlData } from "../../../services/CryptoService";
import AddProjectEnvironment from "./ProjectEnvironment/AddProjectEnvironment";
import { ProjectEnvironmentGridConfig } from "./ProjectEnvironment/config/ProjectEnvironment.data";
import ToastService from "../../../services/toastService/ToastService";
/** RTK Query */
import {
  useDeleteProjectEnvironmentByIdMutation,
  useLazyGetProjectEnvironmentByIdQuery
} from "../../../app/services/projectenvironmentAPI";

const ProjectEnvironment = forwardRef((props, ref) => {
  const molGridRef = useRef();
  /* State*/
  const [dataSource, setDataSource] = useState([])
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [projectEnvironmentId, setProjectEnvironmentId] = useState(null);
  const { confirm } = SwalAlert();

  let projectId = null;
  let projectName = '';
  let projectCode = '';

  const { id } = useParams();
  const projectdata = id ? decryptUrlData(id) : null;

  if (typeof projectdata === 'object' && projectdata !== null) {
    projectId = projectdata.projectId;
    projectName = projectdata.projectName;
    projectCode = projectdata.projectCode;

  } else if (projectdata) {
    projectId = projectdata;
  }
  const cardData = [
    { key: projectCode, value: projectName },
  ];

  // API Calls

  const [getProjectEnvironmentById, {
    isLoading: isgetProjectEnvironmentByIdLoading,
    isSuccess: isgetProjectEnvironmentByIdSuccess,
    data: getProjectEnvironmentByIdData
  },] = useLazyGetProjectEnvironmentByIdQuery();

  const [deleteProjectEnvironmentById, {
    isSuccess: isdeleteProjectEnvironmentByIdSuccess,
    data: deleteProjectEnvironmentByIdData
  }] = useDeleteProjectEnvironmentByIdMutation();
  
  //** useEffect's */
  useEffect(() => {
    getProjectEnvironmentById(projectId)
  }, [projectId])

  useEffect(() => {
    if (isgetProjectEnvironmentByIdSuccess && getProjectEnvironmentByIdData) {

      if (getProjectEnvironmentByIdData) {
        setDataSource(getProjectEnvironmentByIdData);
      }
    }
  }, [isgetProjectEnvironmentByIdSuccess, getProjectEnvironmentByIdData]);

  useEffect(() => {
    if (isdeleteProjectEnvironmentByIdSuccess && deleteProjectEnvironmentByIdData) {
      ToastService.success(deleteProjectEnvironmentByIdData.errorMessage);
      getProjectEnvironmentById(projectId)
    }
  }, [isdeleteProjectEnvironmentByIdSuccess && deleteProjectEnvironmentByIdData]);

  //** Funcation's */
  const handleToggleModal = () => {
    setIsModelOpen(true);
  };

  const onEditAction = (data) => {
    setProjectEnvironmentId(data.environmentId);
    setIsModelOpen(true);
  };

  const onSidebarClose = () => {
    setIsModelOpen(false);
    getProjectEnvironmentById(projectId)
    setProjectEnvironmentId(null);
  };

  const onDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProjectEnvironmentById(data.environmentId);
      }
    });
  };

  const actionHandler = {
    EDIT: onEditAction,
    DELETE: onDeleteClick,
  };

  return (

    <div className="table-style">
      <div className="project-Environment center-top-space">
        {/* Filter Section Start */}
        <div className="main-filter-section">
          <CardSection
            // isContentLoading={isProjectVersionListLoading}
            cardTitle={"Project Environment"}
            rightButton={true}
            buttonClassName="theme-btn"
            cardInfo={true}
            cardInfoWrapper={cardData}
            titleButtonClick={handleToggleModal}
            buttonText="Environment"
            textWithIcon={true}
            iconName="material-symbols:add-rounded"
            fontIcon={true}
          // searchInputName="Search by Environment Name"
          // searchInput={true}
          >
            <div className="table-grid">
              <div className="project-list">
                <MolGrid
                  ref={molGridRef}
                  configuration={ProjectEnvironmentGridConfig}
                  dataSource={dataSource}
                  isLoading={isgetProjectEnvironmentByIdLoading}
                  allowPagination={false}
                  // onPageChange={handlePageChange}
                  onActionChange={actionHandler}
                />
              </div>
            </div>
          </CardSection>
        </div>
      </div>
      <div>
        {isModelOpen && (
          <CenterModel
            showModal={isModelOpen}
            handleToggleModal={onSidebarClose}
            modalTitle={
              projectEnvironmentId ? "Update Project Environment" : "Add Project Environment"
            }
            modelSizeClass="w-40"
          >
            <AddProjectEnvironment
              onSidebarClose={onSidebarClose}
              showModal={isModelOpen}
              projectEnvironmentId={projectEnvironmentId}
              projectId={projectId}
            // onSuccess={onSuccess}
            />
          </CenterModel>
        )}
      </div>
    </div>
  );
});

ProjectEnvironment.propTypes = {
  search: PropTypes.string,
  selectedStatusOptions: PropTypes.number,
};

export default ProjectEnvironment;
